export const WHATSAPP_NUMBER = '34692489818'
export const INSTAGRAM_URL = 'https://instagram.com/kevin.boats'
export const MAPS_URL =
  'https://www.google.com/maps/place/BoatRentalUP/@37.9729483,-0.683619,17z/data=!3m1!4b1!4m14!1m7!3m6!1s0xd63072f449d131f:0xa1f52c91a5c4fcee!2sBoatRentalUP!8m2!3d37.9729442!4d-0.6787535!16s%2Fg%2F11w8j21wrm!3m5!1s0xd63072f449d131f:0xa1f52c91a5c4fcee!8m2!3d37.9729442!4d-0.6787535!16s%2Fg%2F11w8j21wrm?entry=ttu&g_ep=EgoyMDI2MDUyNy4wIKXMDSoASAFQAw%3D%3D'
export const LOGO_URL =
  'https://cdn.magicpatterns.com/uploads/qMFbRtxcLknPZtPPTCdCK8/lofo_sin_fondo.png'
export const HERO_BANNER_URL =
  'https://cdn.magicpatterns.com/uploads/qTXTLeBS6JPJKaaTeFEwd5/banner_kevin.png'
